// ============= Workspace Relay Hub Events =============

/**
 * Enumerates workspace-level events raised on the Workspace relay SignalR hub.
 *
 * These cover file operations, workflow changes, Ask lifecycle within
 * a workspace, collection changes, chat messages, and presence.
 */
export enum WorkspaceRelayHubEvents {
  /** Data Room File added to workspace. Fired when a file is successfully processed and added. */
  DATAROOMFILE_ADDED_TO_WORKSPACE = 'DATAROOMFILE_ADDED_TO_WORKSPACE',

  /** File upload errored. Fired when a direct file upload fails. */
  FILE_UPLOAD_ERRORED = 'FILE_UPLOAD_ERRORED',

  /** File upload retry. Fired when a direct file upload is being retried. */
  FILE_UPLOAD_RETRY = 'FILE_UPLOAD_RETRY',

  /** URL upload errored. Fired when a URL-based ingestion fails. */
  URL_UPLOAD_ERRORED = 'URL_UPLOAD_ERRORED',

  /** URL upload retry. Fired when a URL-based ingestion is being retried. */
  URL_UPLOAD_RETRY = 'URL_UPLOAD_RETRY',

  /** Central file upload errored. Fired when a central/background ingestion pipeline fails. */
  CENTRAL_UPLOAD_ERRORED = 'CENTRAL_UPLOAD_ERRORED',

  /** Data Room File deleted from workspace. Fired when a file is successfully deleted. */
  DATAROOMFILE_DELETED_FROM_WORKSPACE = 'DATAROOMFILE_DELETED_FROM_WORKSPACE',

  /** Data Room File delete error. Fired when a file delete operation fails. */
  DATAROOMFILE_DELETE_FROM_WORKSPACE_ERROR = 'DATAROOMFILE_DELETE_FROM_WORKSPACE_ERROR',

  /** Workflow added to workspace. Fired when a new workflow is created or attached. */
  WORKFLOW_ADDED_TO_WORKSPACE = 'WORKFLOW_ADDED_TO_WORKSPACE',

  /** Workflow deleted from workspace. Fired when an existing workflow is removed. */
  WORKFLOW_DELETED_FROM_WORKSPACE = 'WORKFLOW_DELETED_FROM_WORKSPACE',

  /** Collection added to workspace. Fired when a new collection is created or attached. */
  COLLECTION_ADDED_TO_WORKSPACE = 'COLLECTION_ADDED_TO_WORKSPACE',

  /** Collection deleted from workspace. Fired when an existing collection is removed. */
  COLLECTION_DELETED_FROM_WORKSPACE = 'COLLECTION_DELETED_FROM_WORKSPACE',

  /** Collection updated in workspace. Fired when collection metadata or configuration is updated. */
  COLLECTION_UPDATED = 'COLLECTION_UPDATED',

  /** Ask Session added to workspace. Fired when a new Ask session is created or added. */
  ASK_SESSION_ADDED_TO_WORKSPACE = 'ASK_SESSION_ADDED_TO_WORKSPACE',

  /** Ask Session updated in workspace. Fired when details of an Ask session change. */
  ASK_SESSION_UPDATED_IN_WORKSPACE = 'ASK_SESSION_UPDATED_IN_WORKSPACE',

  /** Ask Session deleted from workspace. Fired when an Ask session is removed. */
  ASK_SESSION_DELETED_FROM_WORKSPACE = 'ASK_SESSION_DELETED_FROM_WORKSPACE',

  /** Receive message. Fired when a generic workspace message (chat/notification) is received. */
  RECEIVE_MESSAGE = 'ReceiveMessage',

  /** User online. Fired when a user is marked as online within the workspace. */
  USER_ONLINE = 'USER_ONLINE',

  /** User offline. Fired when a user is marked as offline within the workspace. */
  USER_OFFLINE = 'USER_OFFLINE',

  /** User connected to workspace. Fired when a user is connected to the workspace. */
  USER_CONNECTED_TO_WORKSPACE = 'USER_CONNECTED_TO_WORKSPACE',

  /** User disconnected from workspace. Fired when a user is disconnected from the workspace. */
  USER_DISCONNECTED_FROM_WORKSPACE = 'USER_DISCONNECTED_FROM_WORKSPACE',
}
